module.exports = __webpack_public_path__ + "static/media/Week 4 Wednesday.c0eb093f.png";